const stylesCommon = {
    mainContainer: {
        backgroundColor: "#e6e6fa",
        height: "100%"
    },
    spinner: {
        backgroundColor: "#e6e6fa",
        color: "#00bfff"
    },
    itemName: {
        color: "#00bfff",
        fontSize: 30
    },
    button: {
        height: 40,
        width: 300,
        maxWidth: "100%"
    },
    loginCard: {
        paddingTop: "5%",
        paddingBottom: "5%",
        paddingRight: "30%",
        paddingLeft: "30%"
    },
    companyLogo: {
        height: 300,
        width: 300,
        maxWidth: "100%"
    },
    edmLogo: {
        height: 50,
        width: 100,
    },
    loginContainer: {
        height: 50,
        display: 'block'
    },
    deleteButtonAlert: {

        marginRight: 10
    },
    cancelButtonAlert: {
        marginRight: 10
    },
    changeUser: {
        fontsize: 14
    },
    fa: {
        marginRight: 3,
        paddingLeft: 5
    },
    title: {
        fontsize: 3
    }
}
export default stylesCommon